import { render, staticRenderFns } from "./RejectReasonDialog.vue?vue&type=template&id=05f8c0b4&scoped=true"
import script from "./RejectReasonDialog.vue?vue&type=script&lang=js"
export * from "./RejectReasonDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f8c0b4",
  null
  
)

export default component.exports